module.exports = __webpack_public_path__ + "static/media/west-campus.70a0cd6d.jp2";